import { fourRetailConfiguration } from "./configuration/4Retail";
import { adiquimicaConfiguration } from "./configuration/Adiquimica";
import { businessCentralConfiguration } from "./configuration/businessCentral";
import { businessCentralOnPremConfiguration } from "./configuration/businessCentralOnPrem";
import { cegidEkonConfiguration } from "./configuration/cegidEkon";
import { holdedConfiguration } from "./configuration/holded";
import { homeserveConfiguration } from "./configuration/homeserve";
import { matiesAmer } from "./configuration/matiesAmer";
import { netSuiteConfiguration } from "./configuration/netsuite";
import { odooConfiguration } from "./configuration/Odoo";
import { sagardiConfigurations } from "./configuration/sagardi";
import { sage } from "./configuration/sage";
import { sapboneConfiguration } from "./configuration/sapboneConfiguration";
import { voloteaConfiguration } from "./configuration/volotea";

const integration = {
  integrations_connected: `Integraciones conectadas`,
  integration_not_connected: `Aún no tienes ninguna integración conectada`,
  erp_connected: `ERP conectado`,
  new_integration_button_text: `Agregar una nueva integración`,
  add_integration: `Agregar una integración`,
  data_source_connected: `Fuente de datos conectada`,
  available_integrations: `Integraciones disponibles para conectar`,
  ERP: `ERP`,
  data_sources: "Fuentes de Datos",
  data_sinks: `receptores de datos`,
  payment_gateways: `Pasarelas de pago`,
  disconnected_successfully: `{{erpName}} Desconectado exitosamente`,
  connected_successfully: `{{erpName}} de conexión retenida enviada`,
  unable_to_connect: `No se puede conectar con {{erpName}}`,
  last_sync_date: `Fecha de última sincronización`,
  last_sync: `Última sincronización`,
  sync_now: `Sincronizar ahora`,
  there_were_some_issues_encountered_during_the_synchronization_process: `Se encontraron algunos problemas durante el proceso de sincronización`,
  entities_being_synced: `Entidades que se están sincronizando`,
  enable_vendor_sync_for_supplier_portal: `Habilitar la sincronización de proveedores para el portal de proveedores`,
  enable_supplier_sync_for_supplier_portal: `Habilitar la sincronización de proveedores para el portal de proveedores`,
  enable_po_sync_for_discrepancy: `Habilitar la sincronización de órdenes de compra para discrepancias`,
  enable_DN_sync_for_discrepancy: `Habilitar la sincronización de notas de entrega para discrepancias`,

  enable_payment_details_sync: `Habilitar la sincronización de detalles de pago`,
  enable_payment_integration: `Habilitar la integración de pagos`,
  enable_email_on_total_amount_mismatch: `Habilitar correo electrónico en discrepancia de monto total`,
  add_single_or_multiple_api_keys_by_pressing_enter: `Agregue una o varias claves API presionando 'Enter' después de cada una.`,
  disconnect_integration: `Desconectar {{integration}}`,
  disconnect_integration_warning: `¿Está seguro de que desea desconectar {{integration}}? Una vez desconectada, se perderán todas las configuraciones.`,
  payment_detail_sync_helper_text: ` Sincronizar registros de pago de NetSuite al portal`,
  enable_payment_integration_helper_text: `Permitir la integración de pagos en NetSuite desde el portal`,
  onboarding_required: `Se requiere incorporación`,
  onboarding_complete: `Incorporación completa`,

  configurations_updated_successfully: `Configuraciones actualizadas correctamente`,
  xero_configurations: `Configuraciones de Xero`,
  enable_purchase_order_sync: `Habilitar la sincronización de órdenes de compra`,
  disable_integration_on_integrated_document:
    "Evitar la reintegración en el documento integrado",
  disable_integration_on_integrated_document_helper_text:
    "Si está habilitado, los cambios realizados después de la integración no se incluirán en futuras integraciones.",
  SlackNotificationApp: `Slack`,
  WhatsAppNotificationApp: `WhatsApp`,
  notification_apps: `Aplicaciones de notificación`,
  "Connect to your Slack account to get all your notifcations.": `Conéctate a tu cuenta de Slack para recibir todas tus notificaciones.`,
  notification_app_connected: `Aplicaciones de notificación conectadas`,
  userNotificationApp_not_found: `Aplicación de notificación no encontrada`,
  cannot_connect_more_than_one_notification_of_same_type: `No se puede conectar más de una aplicación de notificación del mismo tipo`,
  notificationapp_module_is_not_enabled: `El módulo de aplicación de notificación no está habilitado`,
  token_has_expired: `El token ha expirado, por favor intente conectar de nuevo`,
  disconnect_notification: `Desconectar notificación de {{notification}}`,
  disconnect_notification_warning: `¿Está seguro de que desea desconectar la notificación {{notification}}? Una vez desconectada, ya no recibirá notificaciones.`,
  bank_connections: `Conexiones Bancarias`,
  ...businessCentralConfiguration,
  ...businessCentralOnPremConfiguration,
  ...holdedConfiguration,
  ...netSuiteConfiguration,
  ...fourRetailConfiguration,
  ...sage,
  ...matiesAmer,
  ...cegidEkonConfiguration,
  ...sagardiConfigurations,
  ...odooConfiguration,
  ...adiquimicaConfiguration,
  ...voloteaConfiguration,
  ...sapboneConfiguration,
  ...homeserveConfiguration,
};

export default integration;
